export function currency(value: number): string {
	const formatter = new Intl.NumberFormat('id-ID', {
		style: 'currency',
		currency: 'IDR',
		maximumFractionDigits: 0
	})
	const result = formatter
		.format(value || 0)
		.replace('Rp', '')
		.trim()
	return result
}
